/**
 * This file serves as a wrapper for the TextInput component from the @moneris-portal/input package.
 * It is required to centralize the import and ensure that the associated SCSS styles are applied
 * consistently across the application wherever the TextInput component is used.
 * The styles without this wrapper do not get imported properly for some reason.
 */
import { TextInput } from "@moneris-portal/input";
import '../css/TextInputWrapper.scss'


export default TextInput;